module.exports = __webpack_public_path__ + "images/emoji/white_flower.3f5052fc97972e239a0d.png";